
import { Component, Vue, Prop, Watch, Emit, Ref, Mixins } from 'vue-property-decorator'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'
import { dataSource_topicManagerFilter } from '@xt/client/dataSource/kindred-spirit'
import { EnumJoinStatus, EnumGuildMemberType, EnumJoinGroupStatus, EnumMemberStatus } from '@xt/client/enums/kindred-spirit'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import lodash from 'lodash'
import { Observer } from 'mobx-vue'
import { dataSource_My } from '@xt/client/dataSource/my'
import ConfirmModal from '../components/ConfirmModal/index.vue'
import { ConfirmModalOptions } from '@xt/client/entities/kindred-spirit/kindred-spirit'
import { Bind, Debounce } from 'lodash-decorators'

@Observer
@Component({
  components: {
    HeaderImage,
    InfiniteLoading,
    ConfirmModal
  },
  async asyncData(ctx) {
    const guildId = ctx.query.id as string
    // 初始化页面数据
    await ctx.store.$tonghao.Manager.initPage()

    if (!ctx.store.$tonghao.Manager.joinedCity) {
      ctx.redirect('/')
    }

    // 是否是负责人前置校验
    const { id, memberType } = ctx.store.$tonghao.Manager.joinedCity!
    const isManager = id === guildId && memberType === EnumGuildMemberType.Manager

    if (!isManager) {
      ctx.redirect('/')
    }
  },
  validate({ query }) {
    return /^\d+$/.test(query.id as string)
  }
})
export default class ManagerPage extends Vue {
  searchValue: string = ''
  filterValue: string = ''

  visible: boolean = false

  // 本地缓存弹窗显示状态，key为memberId，value为显隐布尔
  popVisibleMap = new Map<string, boolean>()

  @Ref()
  confirmModal: {
    show: (options: ConfirmModalOptions) => Promise<boolean>
  }

  get guildId() {
    return this.$route.query.id as string
  }

  get EnumMemberStatus() {
    return EnumMemberStatus
  }

  get EnumJoinGroupStatus() {
    return EnumJoinGroupStatus
  }

  get body() {
    return {
      guildId: this.guildId,
      status: this.filterValue ?? undefined,
      keyword: this.searchValue ?? undefined
    }
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  get PageStore() {
    return this.$store.$tonghao.Manager
  }

  get filterLabel() {
    const i = lodash.find(dataSource_topicManagerFilter, ['key', this.filterValue])
    return i ? i.label : dataSource_topicManagerFilter[0].label
  }

  get sortOptions() {
    return dataSource_topicManagerFilter
  }

  @Debounce(300, { leading: true, trailing: false })
  @Bind()
  handleCopy(text: string) {
    const disappear = 'position: fixed;z-index: -2;top: -100px'
    let input = document.createElement('input')
    input.value = text
    input.setAttribute('style', disappear)
    document.body.appendChild(input)
    input.focus()
    input.select()
    if (document.execCommand('copy', false, undefined)) {
      //success info
      this.$msg('复制成功', 'success')
    } else {
      this.$msg('请手动复制ID号')
    }
    document.body.removeChild(input)
  }

  async openUserInfoModal(user, key: 'exit' | 'remove' | 'join') {
    let confirmText: string = ''

    if (key === 'join') {
      confirmText = '确认入群'
    } else if (key === 'exit') {
      confirmText = '确认退出'
    } else if (key === 'remove') {
      confirmText = '确认移出'
    }

    const res = await this.confirmModal.show({
      layoutClassName: 'user-info-confirm-modal',
      confirmedHide: true,
      confirmText,
      cancelText: '取消',
      contentData: user
    })

    if (res === true) {
      if (key === 'join') {
        this.handleJoin(user.memberId)
      } else if (key === 'exit') {
        const res = await this.PageStore.exitAudit({
          guildId: this.guildId,
          memberId: user.memberId
        })
        if (res === true) {
          this.$message.success('退出成功')
          const old = this.toJS(this.PageStore.statistics)
          const newwaitExitCount = Math.max(0, old.waitExitCount - 1)
          this.PageStore.setStatistics({
            waitExitCount: newwaitExitCount
          })

          // 管理员自己退出时直接弹到首页
          if (user.memberId === this.UserInfo.id) {
            this.$router.push('/')
            return
          }

          const oldList = this.toJS(this.PageStore.pagePagination.dataSource)
          const newList = oldList.filter(i => i.memberId !== user.memberId)
          this.PageStore.pagePagination.updateSource(newList)
        }
      } else if (key === 'remove') {
        const res = await this.PageStore.exitAudit({
          guildId: this.guildId,
          memberId: user.memberId
        })
        if (res === true) {
          this.$message.success('移出成功')
          const oldList = this.toJS(this.PageStore.pagePagination.dataSource)
          const newList = oldList.filter(i => i.memberId !== user.memberId)
          this.PageStore.pagePagination.updateSource(newList)
        }
      }
    }
  }

  async handleJoin(memberId: string) {
    const res = await this.PageStore.joinGroup({
      guildId: this.guildId,
      memberId
    })

    if (res === true) {
      this.$message.success('入群成功')
      const old = this.toJS(this.PageStore.statistics)
      const newWaitJoinGroupCount = Math.max(0, old.waitJoinGroupCount - 1)
      this.PageStore.setStatistics({
        waitJoinGroupCount: newWaitJoinGroupCount
      })
      const oldList = this.toJS(this.PageStore.pagePagination.dataSource)
      const newList = oldList.map(i => {
        if (i.memberId === memberId) {
          i.joinGroup = EnumJoinGroupStatus.InGroup
        }
        return i
      })
      this.PageStore.pagePagination.updateSource(newList)
    }
  }

  getlabelStyle(item: string) {
    const styles: Array<string> = []
    const option = dataSource_My.specialtyOptions.filter(i => i.value === item)

    if (!option.length) return ''

    styles.push(`color: ${option[0].color}`)
    styles.push(`background: ${option[0].background}`)

    return styles.join(';')
  }

  handleFilter({ key, domEvent }: { key: EnumJoinStatus; domEvent: MouseEvent }) {
    // 防止点击下拉菜单再次弹出
    domEvent.stopPropagation()

    if (this.filterValue === key) return

    this.filterValue = key

    this.refreshList()
  }

  refreshList() {
    this.PageStore.pagePagination.clearData(this.body)
  }

  toMemberCenter(memberId: string) {
    if (!memberId) return

    window.open(`/my/center?memberId=${memberId}`, '_blank')
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
